import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { useHistory, useParams } from "react-router";
import validatePermissions from "Utils/validatePermissions";
import { Form, FormikProvider } from "formik";

import { useSelector } from "react-redux";
import { Store } from "Reducers/interface";
import { FormUnit } from "../components/Form";
import { useUnit } from "../useUnit";

export const CreateUnit = () => {
  const { id: params_id } = useParams<{ id: string }>();

  const { formik } = useUnit(params_id);
  const user_permissions = useSelector(
    (state: Store) => state.User.permissions
  );
  const history = useHistory();

  return (
    <PageWrapper className="entry-app-content">
      <FormikProvider value={formik}>
        <div className="content-holder ">
          <div className="page-heading">
            <div className="wrapper-header-content">
              <PageHeader title="Cadastrar unidades">
                <Breadcrumb
                  list={[
                    {
                      path: "/unidades",
                      label: "Unidades",
                      current: false,
                    },
                    {
                      path: "#",
                      label: "Cadastrar unidades",
                      current: true,
                    },
                  ]}
                />
              </PageHeader>

              <div className="actions-holder">
                {validatePermissions("Create Units", user_permissions) && (
                  <div className="actions-holder">
                    <button
                      type="button"
                      className="link link-danger"
                      onClick={() => history.push("/unidades")}
                    >
                      Voltar
                    </button>
                    <button
                      type="submit"
                      form="unit-form"
                      className="button _action"
                      disabled={formik.isSubmitting}
                      onClick={() => formik.handleSubmit()}
                    >
                      Criar
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <Form>
            <FormUnit unitId={params_id || null} />
          </Form>
        </div>
      </FormikProvider>
    </PageWrapper>
  );
};
